import { TableColumnConfig } from "../../components/sql_table/tableMain";

interface ColumnConfig {
    tableName: string;
    columns: TableColumnConfig[];
    sortOrder?: Record<string, 'asc' | 'desc'>;
}

export const getColConfigs = (): Record<string, ColumnConfig> => ({
    pending_approvals: {
        tableName: 'pending_approvals',
        columns: [
            {
                colName: 'rid',
                colHeader: 'RID',
                colType: 'number',
                editable: false,
            },
            {
                colName: 'pdf_ticket_number',
                colHeader: 'Ticket No.',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'pending_row_id',
                colHeader: 'Row ID',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'table_name',
                colHeader: 'Table',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'status',
                colHeader: 'Status',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'request_user',
                colHeader: 'Request User',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'requested_on',
                colHeader: 'Requested On',
                colType: 'datetime',
                editable: false,
            },
            {
                colName: 'action',
                colHeader: 'Action',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'edited_col',
                colHeader: 'Edited Column',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'old_value',
                colHeader: 'Old Value',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'new_value',
                colHeader: 'New Value',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'request_reason',
                colHeader: 'Specified Reason',
                colType: 'text',
                editable: false,
            },
        ],
        sortOrder: { requested_on: 'desc' },
    },
    pending_approvals_resolved: {
        tableName: 'pending_approvals_resolved',
        columns: [
            {
                colName: 'rid',
                colHeader: 'ID',
                colType: 'number',
                editable: false,
            },
            {
                colName: 'pdf_ticket_number',
                colHeader: 'Ticket No.',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'pending_row_id',
                colHeader: 'Row ID',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'table_name',
                colHeader: 'Table',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'status',
                colHeader: 'Status',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'request_user',
                colHeader: 'Request User',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'requested_on',
                colHeader: 'Requested On',
                colType: 'datetime',
                editable: false,
            },
            {
                colName: 'action',
                colHeader: 'Action',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'edited_col',
                colHeader: 'Edited Column',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'old_value',
                colHeader: 'Old Value',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'new_value',
                colHeader: 'New Value',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'request_reason',
                colHeader: 'Specified Reason',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'reviewed_by',
                colHeader: 'Reviewed By',
                colType: 'text',
                editable: false,
            },
            {
                colName: 'reviewed_on',
                colHeader: 'Reviewed On',
                colType: 'datetime',
                editable: false,
            },
            {
                colName: 'approval_notes',
                colHeader: 'Approver Review Notes',
                colType: 'text',
                editable: false,
            }
        ],
        sortOrder: { reviewed_on: 'desc' },
    },
});
